import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiService from '../../services/ApiService';
import { getDefaultRoute } from '../../utils/permissions';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const Login = async(email, password) => {
    const [success, error] = await apiService.post('auth/login', { email: email, password: password });

    if(error) {
      toast.error("Neispravni podaci!");
      return
    }

    localStorage.setItem('token', success.data.token);
    localStorage.setItem('userEmail', email);

    navigate(getDefaultRoute(email));
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    Login(email, password);
  }

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Login</h2>
      <form onSubmit={handleSubmit}>
        {/* Bootstrap form groups for username and password */}
        <div className="mb-3">
          <label htmlFor="username" className="form-label">
            Email:
          </label>
          <input
            type="text"
            className="form-control"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password:
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {/* Bootstrap submit button */}
        <button type="submit" className="btn btn-primary">
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginForm;